import { FaFacebookSquare, FaInstagram } from "react-icons/fa";
import logo from "../../assets/logo.png";

export const Footer = () => {
  const Icon = FaInstagram as unknown as React.FC<React.SVGProps<SVGSVGElement>>;
  const IconFb = FaFacebookSquare as unknown as React.FC<React.SVGProps<SVGSVGElement>>;

  return (
    <footer className="bg-brand-950 text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:px-8">
        <div>
          <img
            src={logo}
            alt="Mind Wonders Logo"
            className="h-16 w-auto rounded-xl bg-white/95 p-2"
          />
          <p className="mt-6 max-w-sm font-display text-xl italic leading-relaxed text-blue-100">
            Cultivating Change, Fostering Connection, Empowering You...
          </p>
          <div className="mt-8 flex items-center gap-4">
            <a
              href="https://www.facebook.com/people/mindwonderswellness/61558178724224/?mibextid=ZbWKwL"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
              className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-all duration-300 hover:-translate-y-1 hover:bg-brand-600"
            >
              <IconFb fontSize={20} />
            </a>
            <a
              href="https://www.instagram.com/mindwonderswellness"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-all duration-300 hover:-translate-y-1 hover:bg-pink-600"
            >
              <Icon fontSize={20} />
            </a>
          </div>
        </div>

        <div className="md:justify-self-end">
          <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-brand-300">
            Visit Us
          </h3>
          <p className="mt-4 max-w-sm leading-relaxed">
            Mind Wonders Psychological Counselling Center, Kurla Camp,
            Ulhasnagar, Thane – 421004
          </p>
          <a
            href="https://maps.google.com/?q=Mind Wonders Psychological Counselling Center, Kurla Camp, Ulhasnagar"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-brand-400/50 px-6 py-3 text-xs font-bold tracking-widest text-white transition-all duration-300 hover:-translate-y-0.5 hover:bg-brand-700"
          >
            <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"
              />
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"
              />
            </svg>
            GET DIRECTIONS
          </a>
          <div className="mt-6 space-y-2">
            <p className="flex items-center gap-3">
              <svg className="h-4 w-4 text-brand-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z"
                />
              </svg>
              +91 – 9699985688
            </p>
            <p className="flex items-center gap-3">
              <svg className="h-4 w-4 text-brand-300" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
                />
              </svg>
              contact@mindwonderswellness.com
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <p className="text-center text-sm text-slate-400">
          © {new Date().getFullYear()} Mind Wonders Psychological Counselling
          Center. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
